import React from 'react';
import { Grid } from '@material-ui/core';
import { useStyles } from './styles';
import { EmailHeaderInterface } from './EmailHeadeerInterface';
import EmailIcon from '@material-ui/icons/Email';
import logoImg from '../../assets/logo.svg';

const EmailHeader: React.FC<EmailHeaderInterface> = ({ ImageUrl, EmailUrl, OrganizationName }) => {
  const classes = useStyles();
  const logoUrl = ImageUrl ? (ImageUrl as string) : logoImg;
  return (
    <Grid container className={classes.emailHeader}>
      <Grid item xs={6}>
        <img src={logoUrl} alt='' className={classes.ImageStyles} />
        <span style={{ marginLeft: '10px', color: 'white' }}>{OrganizationName} </span>
      </Grid>

      <Grid className={classes.IconEmail}>
        <span className={classes.callicon}>
          <EmailIcon />
        </span>
        <span className={classes.footerText}>{EmailUrl}</span>
      </Grid>
    </Grid>
  );
};
export default EmailHeader;
